<template>
    <div class="fm-container"> 
        <Backer />
        <b-overlay :show="purchase_order_being_loaded" rounded="sm">
            <b-card header="Info" style="margin-top: 10px;">
                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">Name</b-card-text>
                    <div class="field-inline-field"><b-input size="sm" v-model="data.po_name" autocomplete="off" ></b-input></div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">
                        PO Number <span v-if="!data.po_number"><b-badge size="sm" variant="secondary" @click="data.po_number=Math.round(Date.now() / 1000);">create</b-badge></span>
                    </b-card-text>
                    <div class="field-inline-field">
                        <b-input size="sm" v-model="data.po_number" autocomplete="off" ></b-input>
                    </div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">Container #</b-card-text>
                    <div class="field-inline-field"><b-input size="sm" v-model="data.container_number" autocomplete="off" ></b-input></div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">Vendor</b-card-text>
                    <div class="field-inline-field">
                        <b-form-select
                            v-model="data.vendor_id"
                            :options="vendors"
                            size="sm"
                        >
                        </b-form-select>
                    </div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">ETA</b-card-text>
                    <div class="field-inline-field">
                        <b-form-datepicker 
                            reset-button
                            size="sm" 
                            placeholder="" 
                            v-model="data.eta"
                            style="width: 150px;"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                        >        
                        </b-form-datepicker>
                    </div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label">Production Status</b-card-text>
                    <div class="field-inline-field">
                        <b-form-select
                            v-model="data.production_status"
                            :options="production_statuses"
                            size="sm"
                        >
                        </b-form-select>
                    </div>
                </div>

                <div class="field-set-inline" style="width: 150px;">
                    <b-card-text class="field-inline-label">Created On:</b-card-text>
                    <div class="field-inline-field">
                        {{ (data.created_on || getNow()) }}
                    </div>
                </div>

                <div class="field-set-inline" style="width: 200px;">
                    <b-card-text class="field-inline-label" style="display: block;">Created By:</b-card-text>
                    <div class="field-inline-field">
                        {{ data.creator || userDetails.username }}
                    </div>
                </div>

                <div class="field-set-inline" style="width: auto;" v-if="data.last_saved_by">
                    <b-card-text class="field-inline-label">Last Saved:</b-card-text>
                    <div class="field-inline-field">
                        {{ data.last_saved_on }} ( by {{ data.last_saved_by }} )
                    </div>
                </div>
            </b-card>

            <div>
                <b-card header="Items">
                    <div style="margin: 10px;">
                        
                        <div class="field-inline-field" style="width: 600px;">
                            
                            <vue-autosuggest
                                ref="autosuggest"
                                v-model="query"
                                @selected="selectHandler"
                                :suggestions="filteredSuggestions"
                                :getSuggestionValue="s => s.item.product_sku +' (' +s.item.product_name + ')' "
                                :inputProps="inputProps"
                                style="width: 600px; position: relative; font-size: 14px;"

                            >
                                <template slot-scope="{ suggestion }">
                                    <div>
                                        <b>{{suggestion.item.product_sku}} ({{ suggestion.item.product_name }})</b>
                                        <!-- <p>- {{suggestion.item.topping.map(topping => topping.type).join(", ")}}</p> -->
                                    </div>
                                </template>
                            </vue-autosuggest>


                        </div>
                        <div class="field-inline-field">
                            <b-button size="sm" variant="success" @click="addItem">Add</b-button>
                            <b-button size="sm" variant="dark" @click="addCustom">Add Custom</b-button>
                        </div>
                    </div>

                    <div style="margin: 10px; " v-if="data.items.length > 0">
                        <table style="width: 100%;">
                            <thead>
                                <tr style="background: #efefef;">
                                    <td class="ipt_tdhr">ID</td>
                                    <td class="ipt_tdhr">SKU</td>
                                    <td class="ipt_tdhr">Name</td>
                                    <td class="ipt_tdhr">Color</td>
                                    <td class="ipt_tdhr">Category</td>
                                    <td class="ipt_tdhr">Landed Cost</td>
                                    <td class="ipt_tdhr">Wholesale Price</td>
                                    <td class="ipt_tdhr">Selling Price</td>
                                    <td class="ipt_tdhr">FOB Price</td>
                                    <td class="ipt_tdhr">Cubes</td>
                                    <td class="ipt_tdhr">Rcv Location</td>
                                    <td class="ipt_tdhr">Ordrd</td>
                                    <td class="ipt_tdhr">Rcvd</td>
                                    <td class="ipt_tdhr">Dmgd</td>
                                    <td class="ipt_tdhr">Diff</td>
                                    <td class="ipt_tdhr">Actions</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,idx in data.items">
                                    <td class="ipt_tdr">
                                        {{ item.product_id }}
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.product_sku" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.product_sku }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.product_name" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.product_name }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <input v-model = "item.color" style="width: auto;"/>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <div style="margin: 3px;">
                                                <b-form-select
                                                    v-model="item.category_id"
                                                    :options="categories"
                                                    size="sm"
                                                >
                                                </b-form-select>
                                            </div>
                                        </span>
                                        <span v-else>
                                            {{ categoriesdict[item.category_id] }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.landed_cost" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.landed_cost }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.wholesale_price" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.wholesale_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.selling_price" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.selling_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.fob_price" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.fob_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.cubes" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.cubes }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <div style="margin: 3px;">
                                            <b-form-select
                                                v-model="item.location_id"
                                                :options="locations"
                                                size="sm"
                                            >
                                            </b-form-select>
                                        </div>
                                        <div style="margin: 3px;">
                                            <b-form-select
                                                v-if="item.location_id != null"
                                                v-model="item.sublocation_id"
                                                :options="sublocations.filter(function(d){return d.location_id == item.location_id})"
                                                size="sm"
                                            >
                                            </b-form-select>
                                        </div>
                                    </td>
                                    <td class="ipt_tdr" style="width: 30px;">
                                        <input v-model="item.ordered_quantity" style="width: 30px; text-align: center"/>
                                    </td>
                                    <td class="ipt_tdr" style="width: 30px;">
                                        <input v-model="item.received_quantity" style="width: 30px; text-align: center"/>
                                    </td>
                                    <td class="ipt_tdr" style="width: 30px;">
                                        <input v-model="item.damaged_quantity" style="width: 30px; text-align: center;"/>
                                    </td>
                                    <td class="ipt_tdr" style="width: 30px;">
                                        <span v-if="item.ordered_quantity != item.received_quantity & item.ordered_quantity != null & item.received_quantity != null" style="background: #FFD54F; padding: 4px;">
                                            {{ (item.ordered_quantity - item.received_quantity || 0) }}
                                        </span>
                                        <span v-else>
                                            {{ (item.ordered_quantity - item.received_quantity || 0) }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdr">
                                        <b-badge style="cursor: pointer; font-size: 12px; margin: 3px;" variant="dark">Images</b-badge>
                                        <b-badge style="cursor: pointer; font-size: 12px; margin: 3px;" variant="danger" @click="removeItemFromPO(idx)">Remove</b-badge>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="margin: 10px;" v-if="data.items.length > 0">
                        <b-button 
                            size="md" 
                            variant="primary" 
                            @click="promptSavePurchaseOrder"
                        >Save</b-button>
                    </div>
                </b-card>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import { VueAutosuggest } from "vue-autosuggest";

    import readXlsxFile from 'read-excel-file'
    import moment from 'moment'


    export default {
        name: "PurchaseOrder",
        props: ["viewdata"],
        components: {Backer,Multiselect,VueGoodTable,readXlsxFile,VueAutosuggest},
        data: function(){
            return {
                userDetails: {properties: {}},
                data: {
                    items: [],
                    container_number: null,
                    po_number: null,
                    po_name: null,
                    vendor_id: null,
                    production_status: null,
                    eta: null,
                    created_on: null,
                    created_by: null,
                    last_saved_by: null,
                },
                purchase_order_being_loaded: false,
                vendors: [],
                vendorsdict: {},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                categories: [],
                categoriesdict: {},
                production_statuses: [
                    // {value: 1, text: "Order Pending"},
                    // {value: 2, text: "Order Approved"},
                    {value: 1, text: "Open Orders"},
                    {value: 3, text: "In Production"},
                    {value: 4, text: "Ready to Ship"},
                    {value: 5, text: "In Transit"},
                    {value: 6, text: "Received"}
                ],
                product_suggestions: [],
                selected: null,
                inputProps: {
                    id: "autosuggest__input",
                    placeholder: "Search SKUs to add"
                },
                query: "",
                po_number: null, //this.$route.params.po_number
            }
        },
        computed: {
            filteredSuggestions() {
                if (!this.query){
                    return []
                }
                return [
                    {
                        data: this.product_suggestions.filter(item => {
                            return (
                                ( 
                                item.product_name.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                                ||
                                item.product_sku.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                                )
                            );
                        })
                    }
                ];
            }
        },
        methods: {
            formatDt: function(dtstr){
                return moment(dtstr).format('MM/DD/YYYY')
            },
            getNow: function(){
                return moment().format("MM/DD/YYYY")
            },
            selectHandler: function(item) {
                if (item) {
                    this.selected = item.item;
                }
            },
            addItem: function(e) {
                if (e){
                    e.preventDefault();
                }
                let item = this.selected;

                item.ordered_quantity = null;
                item.received_quantity = null;
                item.damaged_quantity = null;
                item.color = null;
                item.is_custom = false;

                this.data.items.push(item);
                this.selected = null;
                this.query = "";
                document.getElementById("autosuggest__input").value = null;
            },
            addCustom: function(e) {
                if (e){
                    e.preventDefault();
                }
                let item = {
                    product_id: -1,
                    product_sku: null,
                    product_name: null,
                    category_id: null,
                    landed_cost: null,
                    wholesale_price: null,
                    selling_price: null,
                    fob_price: null,
                    cubes: null,
                    location_id: null,
                    sublocation_id: null,
                    ordered_quantity: null,
                    received_quantity: null,
                    damaged_quantity: null,
                    color: null,
                };

                item.is_custom = true;
                this.data.items.push(item);
                this.selected = null;
                this.query = "";
                document.getElementById("autosuggest__input").value = null;
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/vendor/all2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.vendors = response.data.result.map(function(d){
                                    return {value: d.id, text: d.vendor}
                                });
                                that.vendorsdict = that.vendors.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading vendors list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/category/all2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.categories = response.data.result.map(function(d){
                                    return {value: d.id, text: d.category}
                                });
                                that.categoriesdict = that.categories.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading categories list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/get_products_list_v2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.product_suggestions = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading products list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else{
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function(e){
                if (e){
                    e.preventDefault();
                }

                let po_number = this.po_number;
                if (po_number){
                    let path = "/api/inventory/get_purchase_order/"
                    let data = {po_number: po_number}
                    let that = this;
                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                        }
                        else {
                            that.data = response.data.result;
                        }
                        that.purchase_order_being_loaded = false;
                    }
                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading purchase order.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.purchase_order_being_loaded = false;
                    }
                    this.purchase_order_being_loaded = true;
                    Requestor.getAsyncP(path, data, this, s, f);
                }
            },
            validate: function(data){
                let errors = [];
                let sku_keys = this.product_suggestions.reduce((map, obj) => (map[obj.product_sku.toLowerCase()] = true, map), {});
                let name_keys = this.product_suggestions.reduce((map, obj) => (map[obj.product_name.toLowerCase()] = true, map), {});
                if (!data.po_name){
                    errors.push("PO should have a name.")
                }
                if (!data.vendor_id){
                    errors.push("PO should havbe a specific vendor assigned.")
                }
                if (!data.po_number){
                    errors.push("Please specify a valid PO number.")
                }
                if (!data.eta || !( moment(moment(data.eta).format("MM/DD/YYYY"), "MM/DD/YYYY", true).isValid() ) ) {
                    errors.push("Please specify a valid ETA date.")
                }
                if (!data.production_status){
                    errors.push("Please specify a valid production status")
                }
                let validator_keys = ["product_id", "product_sku", "category_id", "location_id","sublocation_id","ordered_quantity"];

                for (var i=0; i<data.items.length; i++){
                    let item = data.items[i];
                    for (var j=0; j<validator_keys.length; j++){
                        if (!item[validator_keys[j]]){
                            errors.push("All items should have valid "+validator_keys[j]+" specified");
                            break
                        }
                        if (item.is_custom == true){
                            if (sku_keys[item.product_sku.toLowerCase()]){
                                errors.push("SKU (" + item.product_sku+") already exists in the existing products. Please change it.");
                                break
                            }
                            if (name_keys[item.product_name.toLowerCase()]){
                                errors.push("Name (" + item.product_name+") already exists in the existing products. Please change it.");
                                break
                            }
                        }
                    }
                }
                return errors;
            },
            promptSavePurchaseOrder: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let data = this.data;
                this.savePurchaseOrder()

                // if (data.production_status == 6){
                //     //confirm before someone marks something as received, as it will impact the 
                //     //inventory in the requested location.
                //     this.$vex.dialog.confirm({
                //         message: "Please confirm that you are marking it as received. This will add inventory to the requesting location.",
                //         ///placeholder: 'Planet name',
                //         className: 'vex-theme-os',
                //         callback: function (value) {
                //             if (value){

                //             }
                //         }
                //     })
                // }

            },
            savePurchaseOrder: function(e){
                if (e){
                    e.preventDefault();
                }

                let data = this.data;
                if (!data.created_by){
                    data.created_by = this.userDetails.username;
                    data.created_on = this.getNow();
                }
                data.last_saved_by = this.userDetails.username;
                //data.eta = moment(data.eta, "YYYY-MM-DD").format("MM/DD/YYYY")
                let errors = this.validate(data);
                if (errors.length > 0){
                    this.$bvToast.toast(
                        errors[0], 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let path = "/api/inventory/save_purchase_order/";
                let that = this;

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully saved purchase order.", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                        let po_number = response.data.result.po_number;
                        if (po_number) {
                            that.$router.push("/purchase_orders/");
                        }
                    }
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred while trying to save. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            removeItemFromPO: function(idx){

            },
            fillOrder: function(viewdata){
                if (viewdata.items){
                    for (var i=0; i<viewdata.items.length; i++){
                        let product_id = viewdata.items[i].product_id;
                        let product_sku = viewdata.items[i].product_sku;
                        let quantity = viewdata.items[i].quantity;

                        let exists = this.product_suggestions.filter(function(d){
                            return (d.product_id == product_id) && (d.product_sku == product_sku)
                        });
                        if (exists.length > 0){
                            this.selected = exists[0];
                            this.addItem();
                            this.selected = null;
                            this.data.items[this.data.items.length - 1].ordered_quantity = quantity;
                        }
                        else {
                            this.addCustom();
                            this.data.items[this.data.items.length - 1].product_id = product_id;
                            this.data.items[this.data.items.length - 1].product_sku = product_sku;
                            this.data.items[this.data.items.length - 1].ordered_quantity = quantity;
                        }
                    }
                }
                this.data.po_number = viewdata.identifier;
                this.data.vendor_id = viewdata.vendor_id;
                this.data.production_status = 1
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                if (this.viewdata){
                    let viewdata = JSON.parse(JSON.stringify(this.viewdata));
                    this.po_number = viewdata.po_number;
                }
                else {
                    this.po_number = this.$route.params.po_number
                }
                
                this.fetch_init();
            }
        }

    }
</script>

<style scoped>
    .field-inline-label {
        display: inline-block;
        margin-right: 10px;
    }

    .field-inline-field {
        display: inline-block;
        margin-right: 10px;
        margin-top: 2px;
    }

    .field-set-inline {
        display: inline-block;
        margin: 10px;
        vertical-align: block;
    }

    p {
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrder.vue